import { failedOrderPayment } from 'api/definitions/failed-order-payments';
import { GET_FAILED_ORDER_PAYMENT } from '../types';

export const getFailedOrderPayment = (orderId: string) => (dispatch: WtrDispatch) =>
  dispatch({
    types: GET_FAILED_ORDER_PAYMENT.triplet,
    orderId, // this is sent to the reducer
    apiCall: failedOrderPayment.get({
      orderId,
      iHandleStatusCodes: [400, 404, 406, 500, 502, 503, 504], // Handle generic errors but allow 401/403 to redirect to login
    }),
  });
